<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Customer Types"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewTypesForm"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="customerTypes"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
    >
      <template #header>
        <div class="table-header">Related Customer Types</div>
      </template>

      <template #empty> No Related Customer Types Accounts found! </template>
      <template #loading>
        Loading Related Customer Types. Please wait.
      </template>
      <Column field="id" header="Id" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column field="typeCode" header="Display Order" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.typeCode ? slotProps.data.typeCode : "" }}
        </template>
      </Column>
      <Column field="typeName" header="Description" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.typeName ? slotProps.data.typeName : "" }}
        </template>
      </Column>
      <Column field="used" header="Active" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.used !== null ? slotProps.data.used : "" }}
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editCustomerTypes(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="customerTypesForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Customer Type"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col relative">
          <label for="noteHeader">Display Order:</label>
          <InputText
            id="noteHeader"
            v-model.trim="customerType.typeCode"
            required="true"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Description:</label>
          <InputText
            placeholder=""
            :disabled="false"
            :autoResize="true"
            rows="6"
            v-model="customerType.typeName"
          />
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Active:</label>
          <SelectButton
            v-model="customerType.used"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="customerTypesForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Customer types?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteCustomerType"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { settingFormReady } from "./settingsForm";
import CustomerService from "@/service/CustomerService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  customerService: null,
  data: () => ({
    customerTypesForm: false,
    displayConfirmation: false,
    loading: true,
    filters: {},
    customerTypes: null,
    customerType: {},
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ]
  }),
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    openNewTypesForm() {
      this.customerType = { used: true };
      this.customerTypesForm = true;
    },
    openConfirmation(data) {
      this.customerType = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editCustomerTypes(data) {
      this.customerType = { ...data }; // SAL: edit a copy, not the list row
      this.customerTypesForm = true;
    },
    async deleteCustomerType() {
      this.closeConfirmation();
      await this.customerService.deleteCustomerTypes(this.customerType.id);
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Custom type removed",
        life: 5000
      });
      this.getAllCustomerTypes();
      this.getAllActiveCustomerTypesByHard();
    },
    save() {
      if (!settingFormReady(this, this.customerType, "typeName", "Description", "used")) return;
      if (!this.customerType.id) {
        this.customerService
          .postCustomerTypes(this.customerType)
          .then(res => {
            this.customerTypesForm = false;
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Custom type added",
              life: 5000
            });
            this.getAllCustomerTypes();
            this.getAllActiveCustomerTypesByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving customer type",
              life: 5000
            });
          });
      } else {
        this.customerService
          .putCustomerTypes(this.customerType, this.customerType.id)
          .then(res => {
            this.customerTypesForm = false;
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Custom type updated",
              life: 5000
            });
            this.getAllCustomerTypes();
            this.getAllActiveCustomerTypesByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating customer type",
              life: 5000
            });
          });
      }
    },
    getAllCustomerTypes() {
      this.loading = true;

      this.customerService
        .getAllCustomerTypesByHard()
        .then(data => {
          this.customerTypes = data;
          this.loading = false;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer types",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "customertypes"'
          });
        });
    },
    getAllActiveCustomerTypesByHard() {
      this.customerService
        .getAllActiveCustomerTypesByHard()
        .then(data => {})
        .catch(err => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "customertypes"'
          });
        });
    }
  },
  created() {
    this.customerService = new CustomerService();
  },
  mounted() {
    this.getAllCustomerTypes();
  }
};
</script>
